import { Box, Dialog, DialogContent, DialogTitle, styled, Theme, useMediaQuery } from "@mui/material"
import ImageCanvas from "./ImageCanvas"
import {Image as NImage} from 'neurotec-megamatcherid-management-client';
import { THEME } from "../../config";
import DialogTitleClose from "../Misc/Dialog/Components/DialogTitleClose";

const ImageBox = styled(Box)(({theme}) => ({
    width: "80vw",
    height: "70vh",
    maxWidth: THEME.breakpoints.values.lg,
    [theme.breakpoints.down("sm")]: {
        width: "100%"
    }
}));

const Content = styled(DialogContent)(({theme}) => ({
    paddingLeft: "1rem",
    paddingRight: "1rem",
    [theme.breakpoints.down("sm")]: {
        paddingLeft: "0.5rem",
        paddingRight: "0.5rem",
    }
}))

interface IImageDialogProps {
    image: void | NImage | undefined,
    open: boolean,
    onClose: () => void
    isTokenImage?: boolean,
}

const ImageDialog: React.FC<IImageDialogProps> = (props) => {

    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            maxWidth="xl"
            fullScreen={isSmall ? true : false} 
        >
            <DialogTitle>
                <DialogTitleClose title="Image" onClose={props.onClose}/>
            </DialogTitle>
            <Content>
                <ImageBox>
                    <ImageCanvas image={props.image} isTokenImage={props.isTokenImage}/>
                </ImageBox>
            </Content>
        </Dialog>
    )
}

export default ImageDialog